import Vue from 'vue';
import {
  SET_INVITES,
  ADD_NEW_INVITE,
  REMOVE_DELETED_INVITES,
  REMOVE_UNLINKED_USER,
  ADD_LINKED_USER
} from './mutationTypes';

import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';


export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_INVITES](state, { invites, inviteTargetType, inviteTargetId }) {
    if (!state.invites[inviteTargetType]) {
      Vue.set(state.invites, inviteTargetType,{ [inviteTargetId]: invites });
    } else {
      Vue.set(state.invites[inviteTargetType], inviteTargetId, invites);
    }
  },
  [ADD_NEW_INVITE](state, {newInvite, inviteTargetType, inviteTargetId}) {
    if (newInvite) {
      if (!state.invites[inviteTargetType]) {
        Vue.set(state.invites, inviteTargetType, { [inviteTargetId]: [newInvite] });
      }
      else if (!state.invites[inviteTargetType][inviteTargetId]) {
        Vue.set(state.invites[inviteTargetType], inviteTargetId, [newInvite]);
      } else {
        Vue.set(state.invites[inviteTargetType], inviteTargetId, [newInvite, ...state.invites[inviteTargetType][inviteTargetId]]);
      }
    } 
  },
  [REMOVE_DELETED_INVITES](state, {deletedInviteIds, inviteTargetType, inviteTargetId}) {
    if (deletedInviteIds.length && state.invites?.[inviteTargetType]?.[inviteTargetId]?.length) {
      Vue.set(state.invites[inviteTargetType], inviteTargetId,
        state.invites[inviteTargetType][inviteTargetId].filter(i => deletedInviteIds.indexOf(i.id) < 0));
    }
  },
  [REMOVE_UNLINKED_USER](state, {unlinkedUserId, inviteTargetType, inviteTargetId}) {
    if (unlinkedUserId && state.invites?.[inviteTargetType]?.[inviteTargetId]?.length) {
      Vue.set(state.invites[inviteTargetType], inviteTargetId,
        state.invites[inviteTargetType][inviteTargetId].filter(i => i.user?.id != unlinkedUserId));
    }
  },
  [ADD_LINKED_USER](state, {invite, inviteTargetType, inviteTargetId}) {
    if (invite?.user?.id
      && Array.isArray(state.invites?.[inviteTargetType]?.[inviteTargetId])
      && !state.invites[inviteTargetType][inviteTargetId].some(i => i.user?.id == invite.user.id)) {
      Vue.set(state.invites[inviteTargetType], inviteTargetId,
        [...state.invites[inviteTargetType][inviteTargetId], invite]);
    }
  }
};